<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle2" :subheading="subheading2"/>
      <div class="header-btn-box">
        <a @click="toModifyPage" v-if="permissionCodes.indexOf('001009005') !== -1" >修改</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="line-text">园区支付宝账号：</div>
        <div>{{formData2.aliAccountNo || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">园区支付宝PID：</div>
        <div>{{formData2.pid || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">APPID：</div>
        <div>{{formData2.appid || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">授权有效期：</div>
        <div v-if="formData2.authStartTime && formData2.authEndTime">{{formData2.authStartTime}} 至 {{formData2.authEndTime}}</div>
        <div v-else>无</div>
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import {api} from '../../../api/ConfigRoutine'
import {errorHandler} from '../../../../utils/errorHandler'
import {bus} from '../../../../utils/bus'

export default {
  components: {
    TextTitle,
    Breadcrumb},
  name: 'config-routine',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'ali-config'
      }, {
        value: '常规配置'
      }],
      mainTitle2: '园区账户信息',
      subheading2: '学校第三方应用授权信息',
      formData2: {
        aliAccountNo: '',
        pid: '',
        appid: '',
        authStartTime: '',
        authEndTime: ''
      }
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getYqAppInfo()
  },
  methods: {
    toModifyPage () {
      this.$router.push({
        name: 'modify-routine'
      })
    },
    getYqAppInfo () {
      this.$axios.post(api.getYqAppInfo, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data) {
              this.formData2 = data
            }
          }
        })
        .catch(errorHandler('查询园区账户信息失败'))
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigRoutine/ConfigRoutine.vue